import Link from 'found/Link';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NavItem } from 'reactstrap';

import LogoImage from 'src/assets/images/branding/enosi-logo.svg';
import BareNavigation from 'src/components/Navigation/BareNavigation';
import { APIConfig } from 'src/config';

const FALLBACK_PRIMARY_BRAND = {
  imagePath: LogoImage,
  title: 'Enosi',
  type: 'BRAND_PRIMARY',
};

/**
 * Gets navigation branding, falling back to a safe default during error rendering.
 * @returns {{cobrand: object|null, primaryBrand: object}} Navigation branding.
 */
function getBranding() {
  try {
    const apiConfig = APIConfig();

    return {
      cobrand: apiConfig.cobrand(),
      primaryBrand: apiConfig.primaryBrand(),
    };
  } catch {
    return {
      cobrand: null,
      primaryBrand: FALLBACK_PRIMARY_BRAND,
    };
  }
}

/**
 * Description
 * @returns {React.ReactComponentElement} - AuthenticatedErrorNavigation component
 */
function AuthenticatedErrorNavigation() {
  const { cobrand, primaryBrand } = getBranding();

  return (
    <BareNavigation cobrand={cobrand} primaryBrand={primaryBrand}>
      <NavItem>
        <Link to="/logout" className="nav-link">
          <FormattedMessage id="navigation.authenticated_error_navigation.logout.link" defaultMessage="Log out" />
        </Link>
      </NavItem>
    </BareNavigation>
  );
}

export default AuthenticatedErrorNavigation;
